import { render, staticRenderFns } from "./TalentWork.vue?vue&type=template&id=0e0befd9&scoped=true"
import script from "./TalentWork.vue?vue&type=script&lang=js"
export * from "./TalentWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0befd9",
  null
  
)

export default component.exports